import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators } from '@angular/forms';
import { Tooltip } from 'src/app/model/tooltip';
import { UtilService } from 'src/app/shared';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contactNo',
  templateUrl: './contactNo.component.html',
  styleUrls: ['./contactNo.component.scss'],
  providers: [
    {
      provide: NG_VALIDATORS, useExisting: ConntactNoComponent, multi: true
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConntactNoComponent),
      multi: true
    }]


})
export class ConntactNoComponent implements OnInit {

    onTouched: () => void;
  onChange = (value: string) => { }; 
   
  phoneValidator:boolean=false;

  @Input() controllerData;
  @Input() parent: FormGroup;
  @Input() controlName:string;
  //@Input() regexPattern:string
  @Input() pageName: string;
  @Input() pattern
  
  @Input() dobDisabled = false;
  @Output() onChangeHandler: EventEmitter<any> = new EventEmitter<any>();
 
  disabled: boolean;
  private screenName;


  constructor(private utilService: UtilService,
    private router: Router) { }

  ngOnInit() {
    this.getCurrentScreenURL();
    if(this.screenName === 'your health records' || this.screenName === 'dependant health records') {
    
      this.parent.get(this.controlName).setValidators([Validators.required]);
    } else {
      this.parent.get(this.controlName).setValidators([]);
    }
    //this.parent.get(this.controlName).setValidators([Validators.required]);
    
  }

  

writeValue(value: any): void {
  this.controllerData['value'] = value ? value: null;
}
registerOnChange(fn) {
  this.onChange = fn;
}
registerOnTouched(fn: any): void {
  this.onTouched = fn;
}
  primaryBtnClickHandler() {
    // this.primaryBtnClick.emit(true);
  }

  secondaryBtnClickHandler() {
    // this.secondaryBtnClick.emit(true);
  }

  close() {
    // this.closeModal.emit(true);
  }




validate() {
  // tslint:disable-next-line: max-line-length
  let nameReForContactNo: RegExp;
  if (this.pageName === 'your-personal-details' || this.pageName === 'register') {
     nameReForContactNo = /^[0+]\d+(?: ?\d+)*$/g;
  } else {
     nameReForContactNo = /^[0-9]*$/g;
  }
  const forbidden = nameReForContactNo.test(this.parent.get(this.controlName).value);
  

  if (this.parent.get(this.controlName).value) {
    return forbidden ? null : { notValidPhone: true};
    // tslint:disable-next-line:align
    } return null;
}
validateInput = () => {
  this.onChangeHandler.emit();
}

getCurrentScreenURL() {
  this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
  //console.log('this.screenName ', this.screenName);
  return this.screenName;
}

}
